import { __assign } from "tslib";
import React from 'react';
import { BubbleContent } from '@tencent/tea-component';
;
export function BuyBubbleContent(props) {
    return (React.createElement(BubbleContent, __assign({}, props)));
}
//# sourceMappingURL=BuyBubbleContent.js.map